export default __webpack_public_path__ + "static/images/tw.476bcf54.png";